window.vizRenderCheckInterval = null;
window.waitForVisualizationsToRender = (callback) => {
    vizRenderCheckInterval = setInterval(() => {
        let stillLoading = true;

        $(".visualization-container, #aaa, #bbb, #ccc, #ddd, #eee").each(function (index, visualizationContainer) {
            const obj = $(visualizationContainer);
            const children = obj.children("*");

            if (children.length) {
                stillLoading = false;
            }
        });

        if (!stillLoading) {
            clearInterval(window.vizRenderCheckInterval);

            setTimeout(() => {
                $(".code-editor").css({display: "block"});
                $(".visualization-renderer").css({display: "block"});
                $("#renderingVisualizationInFlight").hide();

                if ("function" === typeof callback) {
                    callback();
                }
            }, 2000);
        }
    }, 1000);
};

window.exportSVG = (anchor) => {
    $(".visualization-container").each(function (index, visualizationContainer) {
        const obj = $(visualizationContainer);
        const svg = obj.find("svg")[0];

        // Add XMLNS to make the .SVG render properly
        svg.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
        svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");

        const svgURL = window.URL.createObjectURL(
            new Blob(
                [svg.outerHTML],
                {
                    type: "image/svg+xml",
                }
            )
        );

        let svgFileName = "stjude-cloud.svg";
        const slug = obj.parent().data("slug")
        if ("undefined" !== typeof slug && slug.length) {
            svgFileName = slug + ".svg";
        }

        let a = anchor;
        a.target = "_blank";
        a.download = svgFileName;
        a.href = svgURL;
    });
};

$(() => {
    $(".visualization-renderer").each(function (index, visualizationCanvasComponent) {
        const obj = $(visualizationCanvasComponent);
        const host = obj.data("host");
        const pprJwt = obj.data("ppr-jwt");

        const codeContainerEl = obj.children(".code-container");
        const visualizationContainer = obj.children(".visualization-container");

        let visualizationCode = codeContainerEl.val();
        const isOldCode = codeContainerEl.attr('oldcode');

        // runproteinpaint({clear: 1});
        if (!isOldCode) {
            try {
                visualizationCode = JSON.parse(visualizationCode);
            } catch (e) {
                const parseError = getJSONParseError(visualizationCode);
                alert(parseError.message + " (at line " + parseError.line + " col " + parseError.column + ")\n\n>>>\n>>>" + parseError.snippet + "\n>>>");
            }

            visualizationCode = Object.assign({
                "getDatasetAccessToken": () => pprJwt,
                "host": host,
                "holder": visualizationContainer[0],
                "parseurl": true,
                "nobox": 1,
                "noheader": 1,
            }, visualizationCode);

            runproteinpaint(visualizationCode);

            let visualizationObjectCode = JSON.stringify(visualizationCode, null, 2);
            visualizationObjectCode = visualizationObjectCode.replace('"holder": {}', '"holder": visualizationContainer[0]');
            visualizationObjectCode = 'runproteinpaint(' + visualizationObjectCode + ');';
            window.codemirror[0].setValue(visualizationObjectCode);

            let $this = this
            waitForVisualizationsToRender(function () {
                if (typeof parent !== "undefined") {
                    $this.rendered = true;
                }
            });
        } else {
            // TODO: Modify Visualizations' code directly to apply these changes
            let modifiedCode = visualizationCode.replace(/this\.\$http/, "axios");
            modifiedCode = modifiedCode.replaceAll(/document\.getElementById\([^a-z]+visualization_container[^\)]+\)/g, "visualizationContainer[0]");

            try {
                eval(modifiedCode).then(() => this.rendered = true);
            } catch (e) {
                alert("An error occurred while trying to evaluate the Visualization code, please see console for more details");
                console.log("Error:", e, modifiedCode);
                this.rendered = true;
            }
        }
    });
});
